// Sdílené výpočty Auditu — JEDINÉ místo (rozhodnutí uživatele 2026-10-31,
// dřív tři kopie). Používá je aplikace (Vite: src/ importuje tento soubor)
// i Edge Functions send-overdue-notifications a calendar-feed (Deno, import
// "../_shared/calc.js"; při nasazení přes deploy_edge_function přiložit i tento
// soubor). Jen čisté funkce bez stavu aplikace a bez knihoven.

// ---------- data a termíny plánů ----------
export function isoDateOnly(d) {
  return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
}
export function parseISODateOnly(s) {
  if (!s) return null;
  const d = new Date(s + "T00:00:00");
  return isNaN(d.getTime()) ? null : d;
}
export function addScheduleInterval(date, n, unit) {
  const d = new Date(date.getTime());
  if (unit === "weeks") d.setDate(d.getDate() + 7 * n);
  else if (unit === "months") d.setMonth(d.getMonth() + n);
  else if (unit === "years") d.setFullYear(d.getFullYear() + n);
  else d.setDate(d.getDate() + n); // days
  return d;
}
export function scheduleIntervalMs(freqValue, freqUnit) {
  const v = Math.max(1, parseInt(freqValue, 10) || 1);
  const day = 86400000;
  if (freqUnit === "weeks") return v * 7 * day;
  if (freqUnit === "months") return v * 30 * day;
  if (freqUnit === "years") return v * 365 * day;
  return v * day;
}
// „Neplánovat na víkendy“: plán po dnech počítá jen pracovní dny (víkend se
// přeskočí, celý plán se posune); po týdnech/měsících/letech se termín ze so/ne
// posune na pondělí. Svátky se neřeší.
export function isWeekendDay(d) { const w = d.getDay(); return w === 0 || w === 6; }
export function nextWorkday(d) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  while (isWeekendDay(x)) x.setDate(x.getDate() + 1);
  return x;
}
export function addWorkdays(d, n) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  while (n > 0) { x.setDate(x.getDate() + 1); if (!isWeekendDay(x)) n--; }
  return x;
}
// Termíny plánu v [rangeStart, rangeEnd]: [{date, index}] (index = kolo, rotace).
export function scheduleOccurrencesInRange(schedule, rangeStart, rangeEnd) {
  const out = [];
  const start = parseISODateOnly(schedule.startDate);
  if (!start) return out;
  const freqValue = Math.max(1, parseInt(schedule.freqValue, 10) || 1);
  const freqUnit = schedule.freqUnit || "months";
  const workdays = !!schedule.skipWeekends && freqUnit !== "weeks" && freqUnit !== "months" && freqUnit !== "years";
  let cur = workdays ? nextWorkday(start) : null;
  for (let k = 0; k < 3000; k++) {
    let eff;
    if (workdays) {
      if (k > 0) cur = addWorkdays(cur, freqValue);
      if (cur.getTime() > rangeEnd.getTime()) break;
      eff = new Date(cur.getTime());
    } else {
      const d = addScheduleInterval(start, k * freqValue, freqUnit);
      if (d.getTime() > rangeEnd.getTime()) break;
      eff = (schedule.skipWeekends && isWeekendDay(d)) ? nextWorkday(d) : d;
    }
    if (eff.getTime() >= rangeStart.getTime() && eff.getTime() <= rangeEnd.getTime()) out.push({ date: eff, index: k });
  }
  return out;
}

// ---------- audity, pracoviště, účastníci ----------
// Pracoviště auditu (obchůzka přes víc pracovišť má workplaceIds).
export function auditWorkplaceIds(a) {
  if (!a) return [];
  return (Array.isArray(a.workplaceIds) && a.workplaceIds.length) ? a.workplaceIds : (a.workplaceId ? [a.workplaceId] : []);
}
// „Sklad, Dílna, Kancelář“ / „Sklad, Dílna a 3 další“.
// Podřízená pracoviště (2026-11-03): název „Sklad › Regál A“; getById(id) → pracoviště.
export function workplaceLabelOf(w, getById) {
  if (!w) return "";
  const p = w.parentId ? getById(w.parentId) : null;
  return p ? (p.name || "") + " › " + (w.name || "") : (w.name || "");
}
// Odpovědná osoba pracoviště: vlastní, jinak nadřazeného (podřízená pracoviště,
// rozhodnutí uživatele 2026-11-03). Stejně RLS audit.my_workplace_ids.
export function workplaceResponsibleId(w, getById) {
  if (!w) return "";
  if (w.responsibleUserId) return w.responsibleUserId;
  const p = w.parentId ? getById(w.parentId) : null;
  return (p && p.responsibleUserId) || "";
}
// Pracoviště, na které se plán vztahuje: firma/provozovna/vybraná pracoviště;
// bez vybraných pracovišť („Všechna pracoviště“) jen první úroveň.
export function scheduleIncludesWorkplace(schedule, wpId, w, workplaceExists) {
  const cids = Array.isArray(schedule.companyIds) && schedule.companyIds.length ? schedule.companyIds : null;
  const bids = Array.isArray(schedule.branchIds) && schedule.branchIds.length ? schedule.branchIds : null;
  const wids = Array.isArray(schedule.workplaceIds) && schedule.workplaceIds.length ? schedule.workplaceIds : null;
  if (cids && cids.indexOf(w.companyId) === -1) return false;
  if (bids && bids.indexOf(w.branchId || "") === -1) return false;
  if (wids) return wids.indexOf(wpId) !== -1;
  return !(w.parentId && workplaceExists(w.parentId));
}
export function workplacesLabel(names) {
  names = (names || []).filter(Boolean);
  if (names.length <= 3) return names.join(", ");
  return names.slice(0, 2).join(", ") + " a " + (names.length - 2) + " další";
}
// Zúčastnění, kteří byli přítomni (participantAbsent = nepřítomní).
export function presentParticipantIds(a) {
  const absent = (a && Array.isArray(a.participantAbsent)) ? a.participantAbsent : [];
  return ((a && Array.isArray(a.participantIds)) ? a.participantIds : []).filter((id) => absent.indexOf(id) < 0);
}

// ---------- „termín splněn“ ----------
// Lhůta po termínu (appSettings/scheduleLate, výchozí 7 dní): konec = půlnoc
// po posledním dni lhůty.
export const SCHEDULE_LATE_DEFAULT = 7;
export function lateDeadline(occDate, lateDays) {
  return new Date(occDate.getFullYear(), occDate.getMonth(), occDate.getDate() + (lateDays || 0) + 1).getTime();
}
// Rejstřík uzavřených (nesmazaných) auditů podle „pracoviště|druh“:
// {klíč: [{a, t}]}; obchůzka přes víc pracovišť je u každého svého pracoviště.
export function buildClosedAuditIndex(audits) {
  const idx = Object.create(null);
  for (const a of audits) {
    if (!a || a.status !== "closed" || a.deletedAt || !a.closedAt) continue;
    const t = new Date(a.closedAt).getTime();
    for (const wid of auditWorkplaceIds(a)) {
      const k = (wid || "") + "|" + (a.auditTypeId || "");
      (idx[k] || (idx[k] = [])).push({ a, t });
    }
  }
  return idx;
}
// Termín je splněný: audit s vazbou na termín (scheduleId + datum), jinak
// audit stejného pracoviště a druhu bez vazby v okně ± půl periody, nejpozději
// do konce lhůty, se stejným auditorem (i jako přítomný spoluauditor).
// workplaceId může být pole (obchůzka) — audit bez vazby musí pokrýt všechna.
// index = buildClosedAuditIndex(...) (objekt) nebo Map se stejnými klíči.
export function isOccurrenceFulfilled(index, scheduleId, schedule, occDate, workplaceId, auditorId, lateDays) {
  if (lateDays == null) lateDays = SCHEDULE_LATE_DEFAULT;
  const wps = Array.isArray(workplaceId) ? workplaceId : [workplaceId];
  const key = (wps[0] || "") + "|" + (schedule.auditTypeId || "");
  const list = index && (typeof index.get === "function" ? index.get(key) : index[key]);
  if (!list) return false;
  const occDateStr = isoDateOnly(occDate);
  const half = scheduleIntervalMs(schedule.freqValue, schedule.freqUnit) / 2;
  const from = occDate.getTime() - half, to = Math.min(occDate.getTime() + half, lateDeadline(occDate, lateDays));
  for (const it of list) {
    const a = it.a;
    if (a.scheduleId === scheduleId && a.scheduleOccurrenceDate === occDateStr) return true;
    if (a.scheduleId) continue;
    if (wps.length > 1) {
      const covered = auditWorkplaceIds(a);
      if (!wps.every((w) => covered.indexOf(w) >= 0)) continue;
    }
    if (auditorId && a.auditorId !== auditorId && presentParticipantIds(a).indexOf(auditorId) < 0) continue;
    if (it.t >= from && it.t < to) return true;
  }
  return false;
}

// ---------- auditoři plánu ----------
export const AUDITOR_GROUP_PREFIX = "grp:";
export function isAuditorGroupEntry(entry) {
  return typeof entry === "string" && entry.indexOf(AUDITOR_GROUP_PREFIX) === 0;
}
export function auditorGroupIdFromEntry(entry) { return entry.slice(AUDITOR_GROUP_PREFIX.length); }
// Spoluauditoři termínu: osoby i skupiny (grp:…) rozbalené na členy (podle
// jména), bez auditora termínu a bez duplicit. groupMembers(id) → [uid],
// nameOf(uid) → jméno pro řazení.
export function resolveCoAuditorIds(schedule, auditorId, groupMembers, nameOf) {
  const out = [];
  for (const entry of (Array.isArray(schedule && schedule.coAuditorIds) ? schedule.coAuditorIds : [])) {
    if (!entry) continue;
    let ids = [entry];
    if (isAuditorGroupEntry(entry)) {
      ids = (groupMembers(auditorGroupIdFromEntry(entry)) || []).slice();
      ids.sort((a, b) => String(nameOf(a) || "").localeCompare(String(nameOf(b) || ""), "cs"));
    }
    for (const uid of ids) if (uid && uid !== auditorId && out.indexOf(uid) < 0) out.push(uid);
  }
  return out;
}

// ---------- opatření ----------
// ID opatření OP-[<kód>-]<číslo auditu>-<pořadí>; pořadí = NOK s opatřením
// (otázka, její podotázky, nakonec neshody z volných zjištění).
export function hasCorrectiveAction(x) {
  const ca = x && x.correctiveAction;
  return !!(x && x.result === "NOK" && ca && (ca.description || ca.responsible || ca.dueDate));
}
export function auditCorrectiveSeqMap(a) {
  const map = {};
  let n = 0;
  ((a && a.answers) || []).forEach((ans) => {
    if (hasCorrectiveAction(ans)) map[ans.id] = ++n;
    (ans.subAnswers || []).forEach((sa) => { if (hasCorrectiveAction(sa)) map[ans.id + "::" + sa.id] = ++n; });
  });
  (Array.isArray(a && a.findings) ? a.findings : []).forEach((f) => { if (hasCorrectiveAction(f)) map[f.id] = ++n; });
  return map;
}
export function correctiveCode(a, seq) {
  return (a && a.auditNumber != null && seq) ? "OP-" + (a.auditCode ? a.auditCode + "-" : "") + a.auditNumber + "-" + seq : "";
}

// ---------- notifikace ----------
// Nastavení notifikací uživatele (výchozí hodnoty ze starého notifFrequency).
export function effectiveNotif(p, role) {
  p = p || {};
  const legacyFreq = p.notifFrequency || "never";
  const legacyOn = legacyFreq === "daily" || legacyFreq === "weekly";
  const manager = role === "administrator" || role === "spravce";
  const d = { freq: legacyOn ? legacyFreq : "daily", mine: legacyOn, wp: legacyOn, plan: true,
    orgOverdue: manager && legacyOn, orgMissed: false, tech: role === "administrator" };
  const n = (p.notif && typeof p.notif === "object") ? p.notif : null;
  if (!n) return d;
  for (const k of Object.keys(d)) if (typeof n[k] === typeof d[k]) d[k] = n[k];
  if (d.freq !== "daily" && d.freq !== "weekly") d.freq = "daily";
  return d;
}

// ---------- nastavení organizace (app_settings) ----------
// Řádek app_settings má id „<orgId>:<klíč>“ (od 2026-10-31, dřív jen „<klíč>“,
// což u více organizací kolidovalo). settingKey vrátí „klíč“ pro obě podoby.
export function settingKey(id) {
  const s = String(id || "");
  const i = s.indexOf(":");
  return i >= 0 ? s.slice(i + 1) : s;
}
// Nastavení podle organizace: Map orgId → {klíč: data}; nové řádky (s orgId
// v id) mají přednost před staršími bez něj.
export function settingsByOrg(rows) {
  const out = new Map();
  const sorted = (rows || []).slice().sort((a, b) => (String(a.id).indexOf(":") >= 0 ? 1 : 0) - (String(b.id).indexOf(":") >= 0 ? 1 : 0));
  for (const r of sorted) {
    const d = r.data || {};
    if (!d.orgId) continue;
    const m = out.get(d.orgId) || {};
    m[settingKey(r.id)] = d;
    out.set(d.orgId, m);
  }
  return out;
}
